// import React from 'react';
// import ReactDOM from 'react-dom/client';
// import './index.css';
// import App from './App';
// import reportWebVitals from './reportWebVitals';
// import { ChakraProvider, extendTheme, ThemeConfig } from '@chakra-ui/react';

// const config: ThemeConfig = {
//   initialColorMode: 'light',
//   useSystemColorMode: false,
// };

// const theme = extendTheme({
//   config,
//   styles: {
//     global: {
//       body: {
//         bg: 'gray.900',
//         color: 'white',
//       },
//     },
//   },
//   components: {
//     Button: {
//       defaultProps: {
//         colorScheme: 'blue',
//       },
//     },
//     Box: {
//       baseStyle: {
//         bg: 'gray.900',
//       },
//     },
//     Flex: {
//       baseStyle: {
//         bg: 'gray.900',
//       },
//     },
//   },
// });

// // Ensure dark mode is set in localStorage
// if (typeof window !== 'undefined') {
//   localStorage.setItem('chakra-ui-color-mode', 'light');
// }

// const root = ReactDOM.createRoot(
//   document.getElementById('root') as HTMLElement
// );

// root.render(
//   <React.StrictMode>
//     <ChakraProvider theme={theme}>
//       <App />
//     </ChakraProvider>
//   </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();


import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { 
  ChakraProvider, 
  extendTheme, 
  ThemeConfig, 
  ColorModeScript 
} from '@chakra-ui/react';

// 1. Define your color mode config
const config: ThemeConfig = {
  initialColorMode: 'light',
  useSystemColorMode: false, // Set to true to sync with user's OS preference
};

// 2. Extend the theme to be color-mode aware
const theme = extendTheme({
  config,
  styles: {
    // Use a function to access the colorMode from props
    global: (props: any) => ({
      body: {
        bg: props.colorMode === 'dark' ? 'gray.800' : 'gray.50',
        color: props.colorMode === 'dark' ? 'whiteAlpha.900' : 'gray.800',
      },
    }),
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ChakraProvider theme={theme}>
      {/* 3. Add ColorModeScript right after ChakraProvider */}
      <ColorModeScript initialColorMode={theme.config.initialColorMode} />
      <App />
    </ChakraProvider>
  </React.StrictMode>
);

reportWebVitals();